import React from "react";
import {
  Input,
  Form,
  InputNumber,
  DatePicker as AntDatePicker,
  TimePicker,
  Checkbox,
  Radio,
  Button as AntButton,
} from "antd";

import { IProps } from "./component";
import style from "./antd.module.sass";

import "./override.css";

const { TextArea } = Input;
const { RangePicker } = AntDatePicker;

export const Email = (props: IProps) => {
  const properties = props.json.properties;
  return (
    <Form.Item
      className={"a8-form-item override-common"}
      label={properties.label || "Email"}
    >
      {/* <Input type="email" className={style.formCtlCustom} placeholder={properties.placeholder || 'email'} /> */}
      <Input data-test-id="email" type="email" placeholder={properties.placeholder || "Email"} />
    </Form.Item>
  );
};

export const Text = (props: IProps) => {
  const properties = props.json.properties;
  return (
    <Form.Item
      className={"a8-form-item override-common"}
      label={properties.label || "Text"}
    >
      <Input data-test-id="text" type="text" placeholder={properties.placeholder || "Text"} />
    </Form.Item>
  );
};

export const SingleLine = (props: IProps) => {
  const properties = props.json.properties;
  return (
    <Form.Item
      className={"a8-form-item override-common"}
      label={properties.label || "Single Line"}
    >
      <Input
        data-test-id="single_line"
        type="text"
        placeholder={properties.placeholder || "Singleline comment"}
      />
    </Form.Item>
  );
};

export const MultiLine = (props: IProps) => {
  const properties = props.json.properties;
  return (
    <Form.Item
      className={"a8-form-item override-common"}
      label={properties.label || "Multi Line"}
    >
      <TextArea data-test-id="multi_line" placeholder={properties.placeholder || "Multiline comment"} />
    </Form.Item>
  );
};

export const INumber = (props: IProps) => {
  const properties = props.json.properties;
  return (
    <Form.Item
      className={"a8-form-item override-common"}
      label={(properties && properties.label) || "Number"}
    >
      <InputNumber
        data-test-id="number"
        style={{ width: "100%" }}
        placeholder={(properties && properties.placeholder) || "Number"}
      />
    </Form.Item>
  );
};

export const DatePicker = (props: IProps) => {
  const properties = props.json.properties;

  return (
    <Form.Item
      data-test-id="date_picker"
      className={"a8-form-item override-common"}
      label={properties.label || "Date Picker"}
    >
      {(function () {
        let pickerkey;
        if (properties.rangePicker && !properties.showDate) {
          pickerkey = "rangePicker";
        } else if (properties.showDate && !properties.rangePicker) {
          pickerkey = "DatePicker";
        } else if (
          !properties.rangePicker &&
          !properties.showDate &&
          properties.showTime
        ) {
          pickerkey = "TimePicker";
        } else {
          pickerkey = "DatePicker";
        }

        switch (pickerkey) {
          case "rangePicker":
            return (
              <RangePicker
                data-test-id="range_picker"
                className={"a8RangePicker"}
                placeholder={
                  properties.placeholder || ["Start month", "End month"]
                }
                showTime={properties.showTime}
                format={properties.format}
              />
            );
          case "TimePicker":
            return (
              <TimePicker
                data-test-id="time_picker"
                className={style.a8DatePicker}
                placeholder={properties.placeholder || "Select Time"}
                use12Hours
                format={properties.format}
              />
            );
          case "DatePicker":
            return (
              <AntDatePicker
                data-test-id="select_date"
                showTime={properties.showTime}
                placeholder={properties.placeholder || "Select Date"}
                format={properties.format}
              />
            );
          default:
        }
      })()}
    </Form.Item>
  );
};

export const CheckBox = (props: IProps) => {
  const properties = props.json.properties;
  const options =
    props.json.data && !props.json.data.async && props.json.data.options;
  return (
    <React.Fragment>
      <Form.Item
        className={"a8-form-item override-common"}
        label={properties.label || "Checkbox"}
      >
        {options && options.length > 0 ? (
          <Checkbox.Group
            data-test-id="checkbox"
            options={options}
            style={{ marginBottom: "20px" }}
            className="override-common"
          />
        ) : props.json.data.async ? (
          <h6 className="placeholderStyle">
            Please provide api code in data tab to fetch options
          </h6>
        ) : (
          <h6 className="placeholderStyle">Please add options from data tab</h6>
        )}
      </Form.Item>
    </React.Fragment>
  );
};

export const RadioButton = (props: IProps) => {
  const properties = props.json.properties;
  const options =
    props.json.data && !props.json.data.async && props.json.data.options;
  return (
    <React.Fragment>
      <Form.Item
        data-test-id="radio_button"
        className={"a8-form-item override-common"}
        label={properties.label || "Radiobutton"}
      >
        {options && options.length > 0 ? (
          <Radio.Group
            data-test-id="options"
            options={options}
            style={{ marginBottom: "20px" }}
            className="override-common"
          />
        ) : props.json.data.async ? (
          <h6 className="placeholderStyle">
            Please provide api code in data tab to fetch options
          </h6>
        ) : (
          <h6 className="placeholderStyle">Please add options from data tab</h6>
        )}
      </Form.Item>
    </React.Fragment>
  );
};

export const Button = (props: IProps) => {
  const properties = props.json.properties;
  // const options = props.json.data && !props.json.data.async && props.json.data.options;
  return (
    <div className="override-common" style={{
      display: 'flex',
      alignItems: 'flex-end',
      height: '100%'
    }}>
      <AntButton
        data-test-id="antd_button"
        block
        type={properties.buttonType}
        size={properties.buttonSize}
        shape={properties.buttonshape}
        disabled={properties.disabled}
      // style={properties.buttonSize === 'large' ? { height: 50 } : {}}
      >
        {properties.label || "Button"}
      </AntButton>
    </div>
  );
};
